var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sc-message--text",style:(_vm.messageColors)},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.messageText)}}),(_vm.data.meta)?_c('p',{staticClass:"sc-message--meta",style:({color: _vm.messageColors.color})},[_vm._v(_vm._s(_vm.data.meta))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }